/**
 * TES-2556: a one-line cross-link between near-duplicate sound pages that
 * split the same query (e.g. "tesla duck noise" split almost evenly between
 * a duck-call page and a rubber-duck-toy page). Keeps a visitor who lands on
 * the wrong one from bouncing, and gives Google a de-duplication signal
 * between the two. Keyed by slug; most sounds have no entry.
 */
export const SOUND_CROSS_LINKS: Record<string, { label: string; href: string }> = {
  'quack-classic-duck-honk': {
    label: 'Looking for the toy squeak instead?',
    href: '/sounds/duck-toy-squeak-rubber-ducky-sound',
  },
  'duck-toy-squeak-rubber-ducky-sound': {
    label: 'Looking for the duck call instead?',
    href: '/sounds/quack-classic-duck-honk',
  },
}

export function getSoundCrossLink(slug: string | null | undefined) {
  if (!slug) return null
  return SOUND_CROSS_LINKS[slug] ?? null
}
